// Latest videos from the Sri Sode Vadiraja Matha YouTube channel:
// https://youtube.com/@srisodevadirajamatha
//
// NOTE: Since this is a static frontend, video IDs are curated here.
// Update this list when new videos are published. YouTube's own thumbnail
// URL scheme is used (https://img.youtube.com/vi/{id}/hqdefault.jpg).
export const YOUTUBE_CHANNEL_URL = "https://youtube.com/@srisodevadirajamatha";

export const YOUTUBE_VIDEOS = [
  // { id: "jXIg5tqT24Y", title: "Sri Sode Vadiraja Matha - Latest Video 1", publishedAt: "2026-02-28", duration: "" },
  // { id: "91j_RzqSQmU", title: "Sri Sode Vadiraja Matha - Latest Video 2", publishedAt: "2026-02-14", duration: "" },
  // { id: "2V2cbbp7ya4", title: "Sri Sode Vadiraja Matha - Latest Video 3", publishedAt: "2026-02-05", duration: "" },
  // { id: "laAb8YyBBV8", title: "Sri Vishwavallabha Theertha Sanyasa", publishedAt: "2026-01-22", duration: "" },
  // { id: "0kUuwYg27IA", title: "Sonda King and his Guru", publishedAt: "2026-01-15", duration: "" },
  // { id: "2BDtpA6Vd_4", title: "Narala Kshetra Episode", publishedAt: "2026-01-08", duration: "" },
  // { id: "0Os9Hi-sh7E", title: "Hayagriva Jayanthi at Sonda", publishedAt: "2025-12-20", duration: "" },
  // { id: "YuzeaSUtvu0", title: "Sri Vadiraja Thirtha's glory", publishedAt: "2025-12-05", duration: "" },
];

export const ytThumbnail = (id) =>
  `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
